import { dateHeader, formatCellDate } from './timeModeCell';
import { linkTo } from '../linkTo';
import { SettingsState } from '../../redux/slices/settingsSlice';
import { LocationMehod } from '../../constants/Constants';
import { secondsToDhms } from '../../utils/index';
import LockIcon from '@mui/icons-material/Lock';
import CellTowerIcon from '@mui/icons-material/CellTower';
import SatelliteAltOutlinedIcon from '@mui/icons-material/SatelliteAltOutlined';

export const makeNearReaderColumn = (settings: SettingsState) => {
  const { opsStatusColor, supplyChainStatusColor } = settings;
  const getSupplyChainStatusColor = (statusId) => supplyChainStatusColor?.value.find((v) => v.text === statusId)?.value ?? '';
  const getOpsStatusColor = (statusId) => opsStatusColor?.value.find((v) => v.text === statusId)?.value ?? '';
  const renderLocationMethod = (locationMethod) => {
    return locationMethod === LocationMehod.GPS ? (
      <SatelliteAltOutlinedIcon style={{ color: 'green', fontSize: '1.1rem' }} />
    ) : locationMethod === LocationMehod.NETWORK ? (
      <CellTowerIcon style={{ color: 'blue', fontSize: '1.1rem' }} />
    ) : (
      <></>
    );
  };

  return [
    {
      header: 'Name',
      accessorKey: 'name',
      headerClassName: 'react-table-header-align-center',
      enableColumnFilter: true,
      size: 300,
      cell: ({ row }) => linkTo('/readers', row.original.imei, row.original.name),
    },
    {
      header: 'Imei',
      accessorKey: 'imei',
      headerClassName: 'react-table-header-align-center',
      enableColumnFilter: true,
      size: 140,
      cell: ({ row }) => linkTo('/readers', row.original.imei, row.original.imei),
    },
    {
      header: dateHeader('Reported'),
      accessorKey: 'lastSeenDateTime',
      enableColumnFilter: true,
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row, table }) => formatCellDate(table, row.original.lastSeenDateTime),
    },
    {
      header: 'Battery',
      accessorKey: 'batteryPercent',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const percentage = row.original.batteryPercent ?? 0;
        const color = percentage >= 80 ? 'green' : percentage <= 20 ? 'red' : percentage <= 30 ? 'orange' : '';
        return <span style={{ color: color }}>{percentage}%</span>;
      },
    },
    {
      header: 'Interval',
      accessorKey: 'reportInterval',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => <span> {secondsToDhms(row.original.reportInterval)}</span>,
    },
    {
      header: 'IsMobile',
      accessorKey: 'isMobile',
      enableColumnFilter: true,
      size: 70,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return row.original.isMobile ? 'Yes' : 'No';
      },
    },
    {
      header: 'Ops Status',
      accessorKey: 'opsStatus',
      enableColumnFilter: true,
      size: 90,
      style: { textAlign: 'center' },
      cell: ({ row }) => <span style={{ color: getOpsStatusColor(row.original.opsStatus) }}>{row.original.opsStatusDescr}</span>,
    },
    {
      header: 'Supply Chain',
      accessorKey: 'supplyChainStatusDescr',
      disableSortBy: true,
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row }) => (
        <span style={{ color: getSupplyChainStatusColor(row.original.supplyChainStatus) }}>{row.original.supplyChainStatusDescr}</span>
      ),
    },
    {
      header: 'Location',
      accessorKey: 'stationIataCode',
      enableColumnFilter: true,
      size: 70,
      style: { textAlign: 'center' },
    },
    {
      header: 'On Premise',
      accessorKey: 'isOnAirport',
      enableColumnFilter: true,
      size: 90,
      cell: ({ row }) => (row.original.isOnAirport ? 'True' : 'False'),
      style: { textAlign: 'center' },
    },
    {
      header: 'Method',
      accessorKey: 'locationMethod',
      enableColumnFilter: true,
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => <span title={row.original.locationMethodDescr}>{renderLocationMethod(row.original.locationMethod)}</span>,
    },
    {
      header: 'Locked',
      accessorKey: 'lockedLocation',
      size: 55,
      cell: ({ row }) => row.original.lockedLocation && <LockIcon style={{ color: 'green', marginLeft: 10, fontSize: '1.1rem' }} />,
    },
  ] as Array<any>;
};
